(function () {
  var installedFlag = '__fastrrGoogleAdsBeginCheckoutBridgeInstalled';
  var googleAnalyticsDestination = 'G-9092LRN08J';
  var googleAdsDestination = 'AW-16638022144/bi2HCMOVxsIZEICk0P09';

  if (window[installedFlag]) return;
  window[installedFlag] = true;

  window.dataLayer = window.dataLayer || [];

  var originalPush = window.dataLayer.push.bind(window.dataLayer);

  window.dataLayer.push = function () {
    var entries = Array.prototype.slice.call(arguments);
    var result = originalPush.apply(null, entries);

    entries.forEach(function (entry) {
      if (!entry || entry[0] !== 'event' || entry[1] !== 'begin_checkout') return;

      var eventParams = entry[2] || {};
      if (eventParams.send_to !== googleAnalyticsDestination) return;
      if (typeof window.gtag !== 'function') return;

      window.gtag('event', 'begin_checkout', {
        send_to: googleAdsDestination,
        ecomm_prodid: eventParams.ecomm_prodid,
        ecomm_totalvalue: eventParams.ecomm_totalvalue || eventParams.value,
        ecomm_pagetype: eventParams.ecomm_pagetype || 'cart',
        value: eventParams.value,
        currency: eventParams.currency,
        items: eventParams.items
      });
    });

    return result;
  };
})();
